import type { UseQueryResult } from "@tanstack/react-query";

import { useUserScopedQuery } from "../../query/scope";
import { fetchAvailableOrganizations, type AvailableOrgResponse } from "./api";

// Хук «список организаций, доступных текущему пользователю»
// (`GET /api/v1/me/organizations`). Источник кардинальности для
// `SelectOrgPage` (`decideOrgSelection`). User-scoped запрос (см.
// `src/query/scope.ts`) — список принадлежит пользователю, а не
// организации, смена активной организации его не меняет.
//
// `retry: false` — ошибку показываем сразу, повтор — по явному клику
// «Повторить».
//
// `key` НЕ под префиксом `["me", ...]` — тот принадлежит `useMe.ts`, и
// `useSwitchOrganization` целиком сносит его (`removeQueries({ queryKey:
// ["me"] })`, префиксный матч). Список организаций — независимый от
// `useMe` запрос, свой неймспейс ключа не даёт инвалидации одного
// случайно задеть другой.
export function useAvailableOrganizations(): UseQueryResult<
  AvailableOrgResponse[],
  Error
> {
  return useUserScopedQuery<AvailableOrgResponse[]>({
    key: ["available-organizations"],
    queryFn: () => fetchAvailableOrganizations(),
    retry: false,
  });
}
